<template lang="pug">
.vue-time-entries-weekly.table-wrapper
  .scrollable
    table.has-actions.table
      thead
        tr
          td
          AppTimeGridHeaderTableData(
            v-for="date in dateRange"
            :key="date.format()"
            :date="date"
            :zone="currentZone.name"
          )
          td.row-header.text-center
            .total.strong Total
      TimeEntriesWeeklyCopyGrid(
        v-if="showCopyGrid"
        :date-range="dateRange"
      )
      tbody(v-if="!timeEntriesIsEmpty || (timeEntriesIsEmpty && !showCopyGrid)")
        TimeEntriesWeeklyTableRow(
          v-for="projectTaskTimeEntries in timeEntriesByProjectAndTask"
          :key="projectTaskKey(projectTaskTimeEntries[0])"
          :date-range="dateRange"
          :time-entries="projectTaskTimeEntries"
          :project="getProject(projectTaskTimeEntries[0].project_id)"
          :task="getTask(projectTaskTimeEntries[0].task_id)"
          :work-break="projectTaskTimeEntries[0].work_break"
          :work-break-policy-id="projectTaskTimeEntries[0].work_break_policy_id"
          :paid="projectTaskTimeEntries[0].billable"
        )
        TimeEntriesWeeklyEmptyTableRow(
          v-if="timeEntriesIsEmpty && !showCopyGrid"
          :date-range="dateRange"
        )
      tfoot
        tr
          td.strong.text-center {{ allProjectsText }}
          td.strong.total.row-footer.text-center(
            v-for="(date, index) in dateRange"
            :key="`${date.format()}-${index}`"
            :class="{ 'is-today': isToday(date) }"
          )
            | {{ durationByDate(date) | formatDuration(null, '-') }}
          td.strong.weekly-table-total.row-footer.vue-time-entries-weekly-table-row-table-data
            | {{ sumDuration(timeEntriesForWeekly) | formatDuration(null, '-') }}
</template>
<script>
import { mapGetters } from 'vuex';
import { groupBy, isEmpty } from 'lodash-es';
import { getProjectFlavourLabel } from '~/utils/project_flavour';

export default {
  name: 'TimeEntriesWeekly',
  props: {
    showCopyGrid: Boolean,
    timeEntries: Array,
  },
  computed: {
    ...mapGetters([
      'getProject',
      'getTask',
      'isToday',
      'filterByDate',
      'currentZone',
      'sumDuration',
      'inPlaceTimeEntries',
      'date',
      'dateRange',
      'projectFlavour',
    ]),
    timeEntriesByProjectAndTask() {
      return groupBy(this.timeEntries, this.projectTaskKey);
    },
    timeEntriesForWeekly() {
      return this.timeEntries.concat(this.inPlaceTimeEntries);
    },
    timeEntriesIsEmpty() {
      return isEmpty(this.timeEntries);
    },
    allProjectsText() {
      const label = getProjectFlavourLabel(this.projectFlavour, true);

      return `All ${label.toLowerCase()}`;
    },
  },
  methods: {
    durationByDate(date) {
      const timeEntriesByDate = this.filterByDate(this.timeEntriesForWeekly, date);

      return this.sumDuration(timeEntriesByDate);
    },
    projectTaskKey(timeEntry) {
      return timeEntry.work_break ? timeEntry.work_break_policy_id : `${timeEntry.project_id}-${timeEntry.task_id}`;
    },
  },
};
</script>
